// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,import_extension=js"
// @generated from file visual_node/v1/editor.proto (package visual_node.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_struct } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file visual_node/v1/editor.proto.
 */
export const file_visual_node_v1_editor = /*@__PURE__*/ fileDesc("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", [file_google_protobuf_struct]);
/**
 * Describes the message visual_node.v1.DiagnosticFrame.
 * Use `create(DiagnosticFrameSchema)` to create a new message.
 */
export const DiagnosticFrameSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 0);
/**
 * Describes the message visual_node.v1.ValidationError.
 * Use `create(ValidationErrorSchema)` to create a new message.
 */
export const ValidationErrorSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 1);
/**
 * Describes the message visual_node.v1.PortDefinition.
 * Use `create(PortDefinitionSchema)` to create a new message.
 */
export const PortDefinitionSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 2);
/**
 * Describes the message visual_node.v1.ConfigField.
 * Use `create(ConfigFieldSchema)` to create a new message.
 */
export const ConfigFieldSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 3);
/**
 * Describes the message visual_node.v1.NodeDefinition.
 * Use `create(NodeDefinitionSchema)` to create a new message.
 */
export const NodeDefinitionSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 4);
/**
 * Describes the message visual_node.v1.GetNodeRegistryRequest.
 * Use `create(GetNodeRegistryRequestSchema)` to create a new message.
 */
export const GetNodeRegistryRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 5);
/**
 * Describes the message visual_node.v1.GetNodeRegistryResponse.
 * Use `create(GetNodeRegistryResponseSchema)` to create a new message.
 */
export const GetNodeRegistryResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 6);
/**
 * Describes the message visual_node.v1.GetFlowRequest.
 * Use `create(GetFlowRequestSchema)` to create a new message.
 */
export const GetFlowRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 7);
/**
 * Describes the message visual_node.v1.GetFlowResponse.
 * Use `create(GetFlowResponseSchema)` to create a new message.
 */
export const GetFlowResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 8);
/**
 * Describes the message visual_node.v1.SaveFlowRequest.
 * Use `create(SaveFlowRequestSchema)` to create a new message.
 */
export const SaveFlowRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 9);
/**
 * Describes the message visual_node.v1.SaveFlowResponse.
 * Use `create(SaveFlowResponseSchema)` to create a new message.
 */
export const SaveFlowResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 10);
/**
 * Describes the message visual_node.v1.ValidateFlowRequest.
 * Use `create(ValidateFlowRequestSchema)` to create a new message.
 */
export const ValidateFlowRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 11);
/**
 * Describes the message visual_node.v1.ValidateFlowResponse.
 * Use `create(ValidateFlowResponseSchema)` to create a new message.
 */
export const ValidateFlowResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 12);
/**
 * Describes the message visual_node.v1.GenerateCodeRequest.
 * Use `create(GenerateCodeRequestSchema)` to create a new message.
 */
export const GenerateCodeRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 13);
/**
 * Describes the message visual_node.v1.GenerateCodeResponse.
 * Use `create(GenerateCodeResponseSchema)` to create a new message.
 */
export const GenerateCodeResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 14);
/**
 * Describes the message visual_node.v1.WriteGeneratedCodeRequest.
 * Use `create(WriteGeneratedCodeRequestSchema)` to create a new message.
 */
export const WriteGeneratedCodeRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 15);
/**
 * Describes the message visual_node.v1.WriteGeneratedCodeResponse.
 * Use `create(WriteGeneratedCodeResponseSchema)` to create a new message.
 */
export const WriteGeneratedCodeResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 16);
/**
 * Describes the message visual_node.v1.ProjectSettings.
 * Use `create(ProjectSettingsSchema)` to create a new message.
 */
export const ProjectSettingsSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 17);
/**
 * Describes the message visual_node.v1.GetProjectSettingsRequest.
 * Use `create(GetProjectSettingsRequestSchema)` to create a new message.
 */
export const GetProjectSettingsRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 18);
/**
 * Describes the message visual_node.v1.GetProjectSettingsResponse.
 * Use `create(GetProjectSettingsResponseSchema)` to create a new message.
 */
export const GetProjectSettingsResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 19);
/**
 * Describes the message visual_node.v1.UpdateProjectSettingsRequest.
 * Use `create(UpdateProjectSettingsRequestSchema)` to create a new message.
 */
export const UpdateProjectSettingsRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 20);
/**
 * Describes the message visual_node.v1.UpdateProjectSettingsResponse.
 * Use `create(UpdateProjectSettingsResponseSchema)` to create a new message.
 */
export const UpdateProjectSettingsResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 21);
/**
 * Describes the message visual_node.v1.StartRunRequest.
 * Use `create(StartRunRequestSchema)` to create a new message.
 */
export const StartRunRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 22);
/**
 * Describes the message visual_node.v1.RunStarted.
 * Use `create(RunStartedSchema)` to create a new message.
 */
export const RunStartedSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 23);
/**
 * Describes the message visual_node.v1.RunValidationFailure.
 * Use `create(RunValidationFailureSchema)` to create a new message.
 */
export const RunValidationFailureSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 24);
/**
 * Describes the message visual_node.v1.StartRunResponse.
 * Use `create(StartRunResponseSchema)` to create a new message.
 */
export const StartRunResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 25);
/**
 * Describes the message visual_node.v1.StopRunRequest.
 * Use `create(StopRunRequestSchema)` to create a new message.
 */
export const StopRunRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 26);
/**
 * Describes the message visual_node.v1.StopRunResponse.
 * Use `create(StopRunResponseSchema)` to create a new message.
 */
export const StopRunResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 27);
/**
 * Describes the message visual_node.v1.GetRunStatusRequest.
 * Use `create(GetRunStatusRequestSchema)` to create a new message.
 */
export const GetRunStatusRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 28);
/**
 * Describes the message visual_node.v1.GetRunStatusResponse.
 * Use `create(GetRunStatusResponseSchema)` to create a new message.
 */
export const GetRunStatusResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 29);
/**
 * Describes the message visual_node.v1.RunLogsRequest.
 * Use `create(RunLogsRequestSchema)` to create a new message.
 */
export const RunLogsRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 30);
/**
 * Describes the message visual_node.v1.ExitEvent.
 * Use `create(ExitEventSchema)` to create a new message.
 */
export const ExitEventSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 31);
/**
 * Describes the message visual_node.v1.RunLogsResponse.
 * Use `create(RunLogsResponseSchema)` to create a new message.
 */
export const RunLogsResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 32);
/**
 * Describes the message visual_node.v1.FileTreeNode.
 * Use `create(FileTreeNodeSchema)` to create a new message.
 */
export const FileTreeNodeSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 33);
/**
 * @generated from enum visual_node.v1.FileTreeNode.Kind
 */
export var FileTreeNode_Kind;
(function (FileTreeNode_Kind) {
    /**
     * @generated from enum value: KIND_UNSPECIFIED = 0;
     */
    FileTreeNode_Kind[FileTreeNode_Kind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: KIND_FILE = 1;
     */
    FileTreeNode_Kind[FileTreeNode_Kind["FILE"] = 1] = "FILE";
    /**
     * @generated from enum value: KIND_FOLDER = 2;
     */
    FileTreeNode_Kind[FileTreeNode_Kind["FOLDER"] = 2] = "FOLDER";
})(FileTreeNode_Kind || (FileTreeNode_Kind = {}));
/**
 * Describes the enum visual_node.v1.FileTreeNode.Kind.
 */
export const FileTreeNode_KindSchema = /*@__PURE__*/ enumDesc(file_visual_node_v1_editor, 33, 0);
/**
 * Describes the message visual_node.v1.ListFilesRequest.
 * Use `create(ListFilesRequestSchema)` to create a new message.
 */
export const ListFilesRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 34);
/**
 * Describes the message visual_node.v1.ListFilesResponse.
 * Use `create(ListFilesResponseSchema)` to create a new message.
 */
export const ListFilesResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 35);
/**
 * Describes the message visual_node.v1.CreateFolderRequest.
 * Use `create(CreateFolderRequestSchema)` to create a new message.
 */
export const CreateFolderRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 36);
/**
 * Describes the message visual_node.v1.CreateFolderResponse.
 * Use `create(CreateFolderResponseSchema)` to create a new message.
 */
export const CreateFolderResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 37);
/**
 * Describes the message visual_node.v1.CreateBlueprintRequest.
 * Use `create(CreateBlueprintRequestSchema)` to create a new message.
 */
export const CreateBlueprintRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 38);
/**
 * Describes the message visual_node.v1.CreateBlueprintResponse.
 * Use `create(CreateBlueprintResponseSchema)` to create a new message.
 */
export const CreateBlueprintResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 39);
/**
 * Describes the message visual_node.v1.GetBlueprintRequest.
 * Use `create(GetBlueprintRequestSchema)` to create a new message.
 */
export const GetBlueprintRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 40);
/**
 * Describes the message visual_node.v1.GetBlueprintResponse.
 * Use `create(GetBlueprintResponseSchema)` to create a new message.
 */
export const GetBlueprintResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 41);
/**
 * Describes the message visual_node.v1.SaveBlueprintRequest.
 * Use `create(SaveBlueprintRequestSchema)` to create a new message.
 */
export const SaveBlueprintRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 42);
/**
 * Describes the message visual_node.v1.SaveBlueprintResponse.
 * Use `create(SaveBlueprintResponseSchema)` to create a new message.
 */
export const SaveBlueprintResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 43);
/**
 * Describes the message visual_node.v1.RenamePathRequest.
 * Use `create(RenamePathRequestSchema)` to create a new message.
 */
export const RenamePathRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 44);
/**
 * Describes the message visual_node.v1.RenamePathResponse.
 * Use `create(RenamePathResponseSchema)` to create a new message.
 */
export const RenamePathResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 45);
/**
 * Describes the message visual_node.v1.DeletePathRequest.
 * Use `create(DeletePathRequestSchema)` to create a new message.
 */
export const DeletePathRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 46);
/**
 * Describes the message visual_node.v1.DeletePathResponse.
 * Use `create(DeletePathResponseSchema)` to create a new message.
 */
export const DeletePathResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 47);
/**
 * Describes the message visual_node.v1.CompiledProjectFile.
 * Use `create(CompiledProjectFileSchema)` to create a new message.
 */
export const CompiledProjectFileSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 48);
/**
 * Describes the message visual_node.v1.CompileProjectRequest.
 * Use `create(CompileProjectRequestSchema)` to create a new message.
 */
export const CompileProjectRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 49);
/**
 * Describes the message visual_node.v1.CompileProjectResponse.
 * Use `create(CompileProjectResponseSchema)` to create a new message.
 */
export const CompileProjectResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 50);
/**
 * Describes the message visual_node.v1.WrittenProjectFile.
 * Use `create(WrittenProjectFileSchema)` to create a new message.
 */
export const WrittenProjectFileSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 51);
/**
 * Describes the message visual_node.v1.WriteCompiledProjectRequest.
 * Use `create(WriteCompiledProjectRequestSchema)` to create a new message.
 */
export const WriteCompiledProjectRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 52);
/**
 * Describes the message visual_node.v1.WriteCompiledProjectResponse.
 * Use `create(WriteCompiledProjectResponseSchema)` to create a new message.
 */
export const WriteCompiledProjectResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 53);
/**
 * Describes the message visual_node.v1.WriteCompiledFilesRequest.
 * Use `create(WriteCompiledFilesRequestSchema)` to create a new message.
 */
export const WriteCompiledFilesRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 54);
/**
 * Describes the message visual_node.v1.WriteCompiledFilesResponse.
 * Use `create(WriteCompiledFilesResponseSchema)` to create a new message.
 */
export const WriteCompiledFilesResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 55);
/**
 * Describes the message visual_node.v1.FunctionGraphErrorDetail.
 * Use `create(FunctionGraphErrorDetailSchema)` to create a new message.
 */
export const FunctionGraphErrorDetailSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 56);
/**
 * Describes the message visual_node.v1.PreviewFunctionGraphRequest.
 * Use `create(PreviewFunctionGraphRequestSchema)` to create a new message.
 */
export const PreviewFunctionGraphRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 57);
/**
 * Describes the message visual_node.v1.PreviewFunctionGraphResponse.
 * Use `create(PreviewFunctionGraphResponseSchema)` to create a new message.
 */
export const PreviewFunctionGraphResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 58);
/**
 * Describes the message visual_node.v1.InstallPluginRequest.
 * Use `create(InstallPluginRequestSchema)` to create a new message.
 */
export const InstallPluginRequestSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 59);
/**
 * Describes the message visual_node.v1.InstallPluginResponse.
 * Use `create(InstallPluginResponseSchema)` to create a new message.
 */
export const InstallPluginResponseSchema = /*@__PURE__*/ messageDesc(file_visual_node_v1_editor, 60);
/**
 * @generated from enum visual_node.v1.DiagnosticSeverity
 */
export var DiagnosticSeverity;
(function (DiagnosticSeverity) {
    /**
     * @generated from enum value: DIAGNOSTIC_SEVERITY_UNSPECIFIED = 0;
     */
    DiagnosticSeverity[DiagnosticSeverity["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: DIAGNOSTIC_SEVERITY_ERROR = 1;
     */
    DiagnosticSeverity[DiagnosticSeverity["ERROR"] = 1] = "ERROR";
    /**
     * @generated from enum value: DIAGNOSTIC_SEVERITY_WARNING = 2;
     */
    DiagnosticSeverity[DiagnosticSeverity["WARNING"] = 2] = "WARNING";
})(DiagnosticSeverity || (DiagnosticSeverity = {}));
/**
 * Describes the enum visual_node.v1.DiagnosticSeverity.
 */
export const DiagnosticSeveritySchema = /*@__PURE__*/ enumDesc(file_visual_node_v1_editor, 0);
/**
 * EditorService mirrors editor-server's 21 REST endpoints
 * (packages/editor-server/src/routes/*.routes.ts) as gRPC-compatible RPCs, served over
 * Buf Connect. See docs/phase8-backend-grpc-flatbuffers-plan.md for the full migration
 * rationale.
 *
 * Wherever a request/response currently carries a Visual Node `Flow` object
 * (nodes/edges/meta, packages/core/src/schema/node.types.ts), the field below is
 * `bytes flatbuffer_flow` — an opaque FlatBuffers-encoded `Flow` (see
 * packages/core/src/schema/flow.fbs), encoded/decoded by code owned elsewhere. This
 * service definition never re-models the node/edge graph shape in Protobuf.
 *
 * @generated from service visual_node.v1.EditorService
 */
export const EditorService = /*@__PURE__*/ serviceDesc(file_visual_node_v1_editor, 0);
//# sourceMappingURL=editor_pb.js.map